<template>
  <transition-group class="places-list-wrapper" name="list" tag="div">

    <div :key="place.id"
         class="push-place rel"
         v-for="place in places">
      <a :href="place.link" class="link-over">
        <div
          :style="`background-image:url(${place.acf.header_img ? place.acf.header_img.sizes.medium_large : ''})`"
          class="img-wrapper bg">
        </div>
        <div class="push-place-info">

          <p class="city" v-if="place.acf.place_city">
            <span v-html="place.acf.place_city"></span>
            <span v-if="place.acf.place_city_dptnum"> ({{place.acf.place_city_dptnum}})</span>
          </p>
          <h3 v-html="place.title.rendered"></h3>
          <p class="push-subtitle" v-if="place.acf.place_subtitle">{{place.acf.place_subtitle}}</p>
          <p class="push-soon" v-if='place.acf.place_type === "project"'>{{root.contentText.prochainement}}</p>
        </div>
      </a>
    </div>
  </transition-group>
</template>

<script>
  export default {
    name: 'placesList',
    computed: {
      places() {
        return this.$root.filteredPlaces ? this.$root.filteredPlaces : []
      },
      root() {
        return this.$root
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .places-list-wrapper {
    display: flex;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 0 auto;
  }

  .list-enter-active, .list-leave-active {
    transition: all 0.5s;
  }

  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(5px);
  }

  .push-place {
    width: calc(33% - 30px);
    margin: 20px;
    position: relative;
  }

  @media (max-width: 1025px) {
    flex-direction: column;
  }

  .link-over:hover {
    & > .img-wrapper::after {
      opacity: 0.75;
    }
  }

  .push-place {
    height: 360px;
    width: calc(33.33% - 40px);
    position: relative;

    @media (max-width: 1025px) {
      height: 300px;
      width: calc(100% - 40px);
      margin: 10px 20px;
    }
  }

  .img-wrapper {
    height: 100%;
    width: 100%;
    position: absolute;

    &::after {
      content: '';
      display: block;
      height: 100%;
      width: 100%;
      background: linear-gradient(to bottom, rgba(24, 49, 74, 0) 0%, rgba(24, 49, 74, 0.3) 40%, rgba(24, 49, 74, 1) 100%);
      opacity: 1;
      transition: opacity 0.5s;
    }
  }

  .push-place-info {
    width: 100%;
    margin: 20px 0;
    padding: 0 20px 0 40px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    color: #fff;

    &::before {
      content: "";
      display: inline-block;
      width: 2px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 20px;
      background-color: #C7AE6F;
    }

    p {
      margin-top: 0;
      margin-bottom: 3px;
    }

    .city {
      text-transform: uppercase;
      font-size: 14px;
    }

    h3 {
      font-size: 20px;
      font-weight: 700;
      margin-top: 0;
      margin-bottom: 5px;
    }

    .push-soon {
      color: #E86439;
    }
  }

  .link-over {
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .bg {
    background-position: center center;
    background-size: cover;
  }
</style>
